// extracted by mini-css-extract-plugin
export default {"mainHeaderHeight":"--o-main--header-height","mainHeaderHeightCollection":"--o-main--header-height-collection"};